/**
 * @file
 *
 * Identifies keyboard navigation for legacy focus-state styling.
 */

jQuery(document).ready(function() {
	// Determine whether the user is navigating with a keyboard or mouse.
	function handleFirstTab(event) {
		if (event.keyCode === 9) {
			document.body.classList.add('user-is-tabbing');

			window.removeEventListener('keydown', handleFirstTab);
			window.addEventListener('mousedown', handleMouseDownOnce);
		}
	}

	function handleMouseDownOnce() {
		document.body.classList.remove('user-is-tabbing');

		window.removeEventListener('mousedown', handleMouseDownOnce);
		window.addEventListener('keydown', handleFirstTab);
	}

	window.addEventListener('keydown', handleFirstTab);
});
